import React from 'react'

import { withRouter } from 'react-router-dom'

import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { locale, addLocale } from 'primereact/api'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { uniqueId } from 'lodash'
import filesize from 'filesize'
import Upload from '../componentes/Upload/Index'
import FileList from '../componentes/FileList'
import Progresso from '../componentes/Progresso'

import '../../node_modules/admin-lte/dist/css/adminlte.css'
import '../pages/css/plugins/fontawesome-free/css/all.min.css'
import '../../node_modules/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css'
import '../../node_modules/admin-lte/plugins/jqvmap/jqvmap.min.css'
import '../../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css'
import '../../node_modules/admin-lte/plugins/fontawesome-free/css/all.min.css'

import '../../node_modules/admin-lte/plugins/jquery/jquery.min.js'
import '../../node_modules/admin-lte/plugins/jquery-ui/jquery-ui.min.js'
import '../../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import '../../node_modules/admin-lte/plugins/chart.js/Chart.min.js'
import '../../node_modules/admin-lte/plugins/sparklines/sparkline.js'
import '../../node_modules/admin-lte/plugins/jquery-knob/jquery.knob.min.js'
import '../../node_modules/admin-lte/dist/js/adminlte.js'

import '../../node_modules/admin-lte/plugins/datatables/jquery.dataTables.min.js'
import '../../node_modules/admin-lte/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js'
import '../../node_modules/admin-lte/plugins/datatables-responsive/js/dataTables.responsive.min.js'
import '../../node_modules/admin-lte/plugins/datatables-responsive/js/responsive.bootstrap4.min.js'
import '../../node_modules/admin-lte/plugins/datatables-buttons/js/dataTables.buttons.min.js'
import '../../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.bootstrap4.min.js'

import '../../node_modules/primereact/resources/primereact.min.css'
import '../../node_modules/primereact/resources/themes/lara-light-blue/theme.css'
//import '../../node_modules/primereact/resources/themes/mdc-dark-deeppurple/theme.css'
import '../../node_modules/primeicons/primeicons.css'

import '../pages/css/custom.css'

import Logo from '../pages/seguranca/img/logomenu.png'

import LocalStorageService from '../app/service/localStorageService'
import CentralNotificacaoService from '../app/service/CentralNotificacaoService.js';
import UsuarioService from '../app/service/UsuarioService'
import GrupoTrabalhoService from '../app/service/GrupoTrabalhoService'
import UsuarioGrupoTrabalhoService from '../app/service/UsuarioGrupoTrabalhoService'
import ProcessoService from '../app/service/ProcessoService'
import AtividadeService from '../app/service/AtividadeService'
import UploadAtividadeService from '../app/service/UploadAtividadeService'
import ArquivoPessoaService from '../app/service/ArquivoPessoaService'
import PushService from '../app/service/PushService'
import StatusAtividadeService from '../app/service/StatusAtividadeService'
import { AuthContext } from '../main/ProvedorAutenticacao'
import ArquivoAtividadeService from '../app/service/ArquivoAtividadeService'
import TituloAtividadeService from '../app/service/TituloAtividadeService'
import CheckListAtividadeService from '../app/service/CheckListAtividadeService'
import ExecucaoCheckListService from '../app/service/ExecucaoCheckListService'
import PessoaService from '../app/service/PessoaService'
import PublicacoesService from '../app/service/PublicacoesService.js';
import ParametrosPublicacoesService from '../app/service/ParametrosPublicacoesService';
import RodizioAtividadeComponent from '../pages/atividades/RodizioAtividadeComponent.jsx';
import AtividadeInclusaoModal from './AtividadeInclusaoModal';

class Navbar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      classeDiv: 'hide',
      desabilitaBotao: false,
      separador: 'none',
      titulo: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: '',
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      wait: false,
      tipoAtividade: null,
      grupos: [],
      //Usuário de triagem das publicações sem termo (exibe o menu "Prazos sem Responsável")
      usuarioTriagem: false,
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      responsavel: null,
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      processos: [],
      processo: null,
      bloqueiaGrupo: false,
      detail: '',
      consultaProcessoTopo: '',
      //Upload de Arquivos
      upLoadFiles: [],
      nome: '',
      descricao: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      campoPesquisaProcesso: '',
      processoPesquisadoVisivel: '',
      processoPesquisado: '',
      fileData: null,
      fileName: '',
      modalExibirArquivo: false,
      //Central
      quantidadeNotificacoes: '',
      quantidadePush: '',
      //Alteração de Senha
      senhaUsuario: '',
      novaSenha: '',
      confirmacaoSenha: '',
      modalAlterarSenha: false,
      openSpinner: false,
      //Títulos de Atividades
      titulos: [],
      tituloAtividade: null,
      //Recorrência
      recorrencia: null,
      //Informações de Usuários na tarefa
      modalInformacaoUsuario: false,
      grau: [],
      checkList: [],
      //Consulta de Pessoas
      pessoas: [],
			partes: [],
      pessoa: null,
      modalPessoas: false,
      pessoaPesquisa: '',
      pessoaPesquisada: '',
      campoPesquisaPessoa: '',
      pessoaPesquisadaVisivel: '',
      //Novo título de atividade
      novoTitulo: '',
      pontuacao: '',
      modalNovoTitulo: false,
      //Cria novo Grupo de Trabalho
      novoGrupo: '',
      novaDescricaoGrupo: '',
      modalNovoGrupo: false,
      //Publicações
      quantidadePublicacoes: '',
      publicacoes: [],
			//Tudo referente ao Rodízio
			modalRodizio: false,
    };

    this.itens = [];

    this.tiposAtividade = [
      { tipo: 'Tarefa', codigo: 'T' },
      { tipo: 'Compromisso', codigo: 'A' },
    ];

    this.recorrencia = [
      {codigo: '2', nome: '2'},
      {codigo: '3', nome: '3'},
      {codigo: '4', nome: '4'},
      {codigo: '5', nome: '5'},
      {codigo: '6', nome: '6'},
      {codigo: '7', nome: '7'},
      {codigo: '8', nome: '8'},
      {codigo: '9', nome: '9'},
      {codigo: '10', nome: '10'},
      {codigo: '11', nome: '11'},
      {codigo: '12', nome: '12'},
      {codigo: '13', nome: '13'},
      {codigo: '14', nome: '14'},
      {codigo: '15', nome: '15'},
      {codigo: '16', nome: '16'},
      {codigo: '17', nome: '17'},
      {codigo: '18', nome: '18'},
      {codigo: '19', nome: '19'},
      {codigo: '20', nome: '20'},
      {codigo: '21', nome: '21'},
      {codigo: '22', nome: '22'},
      {codigo: '23', nome: '23'},
      {codigo: '24', nome: '24'}
    ];

    this.arquivosAnexo = [];
    this.formData = null;

    this.usuarioService = new UsuarioService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.processoService = new ProcessoService();
    this.atividadeService = new AtividadeService();
    this.uploadAtividadeService = new UploadAtividadeService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.centralService = new CentralNotificacaoService();
    this.pushService = new PushService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.checkListAtividadeService = new CheckListAtividadeService();
    this.execucaoCheckListService = new ExecucaoCheckListService();
    this.pessoaService = new PessoaService();
    this.publicacoesService = new PublicacoesService();
    this.parametrosPublicacoesService = new ParametrosPublicacoesService();

    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.onTipoAtividadeChange = this.onTipoAtividadeChange.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.onGrupoTrabalhoUsuariosAtivosChange = this.onGrupoTrabalhoUsuariosAtivosChange.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.renderFooterProcesso = this.renderFooterProcesso.bind(this);
    this.acoesProcesso = this.acoesProcesso.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.renderFooterInformacaoUsuario = this.renderFooterInformacaoUsuario.bind(this);
    this.onGrauChange = this.onGrauChange.bind(this);
    this.onChangeCheckList = this.onChangeCheckList.bind(this);
    this.acoesPessoa = this.acoesPessoa.bind(this);
    this.renderFooterPessoas = this.renderFooterPessoas.bind(this);
  }

	abrirRodizio = () => {
    this.setState({ modalRodizio: true });
	}

	fecharRodizio = () => {
			this.setState({ modalRodizio: false });
	}

  consultarPessoasPorNomeOuCpf = async () => {
    if(this.state.pessoaPesquisa != '') {
      this.setState({separador: 'block'});
      this.setState({classeDiv: 'show'})
      const usuarioLogado = this.context.usuarioAutenticado;
      await this.pessoaService.consultarPorNomeOuCpf(usuarioLogado.empresa.codigo,this.state.pessoaPesquisa)
        .then(response => {
          this.setState({pessoas: response.data});
          this.abrirModal('modalPessoas');
        }).catch(error => {
          this.setState(error.response.data)
          this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
        });
        this.setState({separador: 'none'});
        this.setState({classeDiv: 'hide'})
    }
  }

  acoesPessoa(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-check" className="p-button-rounded p-button-text" 
                tooltip="Selecionar"
                onClick={() => this.selecionarPessoa(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  renderFooterPessoas(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal('modalPessoas')}/>
        </div>
    );
  }

  async selecionarPessoa(pessoa) {
    this.setState({openSpinner: true});
    await this.pessoaService.consultarPessoa(pessoa.codigo)
      .then(response => {
        this.setState({pessoa: response.data});
        this.setState({pessoaPesquisada: response.data.nome});
        this.setState({campoPesquisaPessoa: 'none'});
        this.setState({pessoaPesquisadoVisivel: 'block'});
        this.fecharModal('modalPessoas');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner: false});
      });
      this.setState({openSpinner: false});
  }

  sairSistema = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.usuarioService.logout({
      usuario: usuarioLogado,
      tipoLog: 'S'
    }).then(response => {
        this.context.encerrarSessao();
    }).catch(error => {
        console.log('Erro ao sair do sistema');
    });
  }

  limparConsultaProcesso = () => {
    LocalStorageService.limparConsultaProcesso();
  }

  limparConsultarPessoas = () => {
    LocalStorageService.limparConsultaPessoas();
  }

  listarTitulos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
      })
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  listarResponsaveisAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressadosAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Cadastrar"
                    disabled={this.state.desabilitaBotao}
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarAtividade}/>
            &nbsp;
            <Button label="Anexar" 
                    disabled={this.state.desabilitaBotao}
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalAnexo('displayAnexo')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Cancelar" 
                    disabled={this.state.desabilitaBotao}
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  renderFooterInformacaoUsuario(name) {
    return (
      <div className="left">
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalAtividade(name)}/>
      </div>
    );
  }

  renderFooterProcesso(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalAtividade() {
    this.setState({ displayAtividade: true });
  }

  abrirModalAnexo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  consultarSubGrupos = async() => {
    await this.grupoTrabalhoService.listarSubGrupos(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  onTipoAtividadeChange(e) {
    this.setState({ tipoAtividade: e.value });
  }

  async onGrupoTrabalhoChange(e) {
    if(e.value != null) {
      await this.setState({selectGrupo: e.value});
      this.consultarSubGrupos();
      this.listarResponsaveis();
      this.listarInteressados();
    } else {
      this.setState({selectGrupo: null});
      this.setState({selectSubGrupo: null});
      this.setState({subGrupos: null});
    }
  }

  async onGrupoTrabalhoUsuariosAtivosChange(e) {
    if(e.value != null) {
      await this.setState({selectGrupo: e.value});
      this.consultarSubGrupos();
      this.listarResponsaveisAtivos();
      this.listarInteressadosAtivos();
    } else {
      this.setState({selectGrupo: null});
      this.setState({selectSubGrupo: null});
      this.setState({subGrupos: null});
    }
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  consultarProcessoPorIndice = async() => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const indice = {
      indice: this.state.pesquisaProcesso,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    this.setState({desabilitaBotao: true});
    await this.processoService.consultarProcessoPorIndice(indice)
      .then(response => {
        this.setState({processos: response.data});
        if(response.data.length > 0) {
          this.abrirModalProcesso('displayProcesso');
        } else {
          this.setState({pesquisaProcesso: ''});
          this.toast.show({severity:'error', summary: 'Processos', detail:'Processo não encontrado', life: 4000});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

    this.setState({separador: 'none'});
    this.setState({classeDiv: 'hide'})
    this.setState({desabilitaBotao: false});
  }

  consultarProcessoTopo = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    const indice = {
      indice: this.state.consultaProcessoTopo,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    this.limparConsultaProcesso();
    LocalStorageService.adicionarConsulta('_consulta_processo_indice', indice);
    this.props.history.push('/processos');
    this.processoService.consultarProcessoPorIndice2(indice)
      .then(response => {
          //this.props.history.push(`?#/processos?indice=${indice.indice}&empresa=${indice.empresa}&usuario=${indice.usuario}`);
          //this.props.history.push('/processos');
          //this.refreshPage();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalProcesso(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  acoesProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-check" className="p-button-rounded p-button-text" 
                tooltip="Selecionar"
                onClick={() => this.selecionarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async consultarUsuariosTarefas(tarefa) {
    await this.tarefaService.listarUsuariosPorTarefa(tarefa.codigo)
      .then(response => {
        this.setState({usuariosTarefas: response.data});
        this.abrirModalInformacaoUsuario('modalInformacaoUsuario');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }


  abrirModalInformacaoUsuario(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  informacoesUsuariosTarefas(rowData) {
    return(
      <React.Fragment>
        <Button icon="fas fa-users" className="p-button-rounded p-button-text" 
                tooltip="Clique para saber os usuários designados para esta tarefa"
                onClick={() => this.consultarUsuariosTarefas(rowData)} 
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async selecionarProcesso(processo) {
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    //this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.processoService.consultarProcessoPorCodigo(processo.codigo, usuarioLogado.codigo)
      .then(response => {
	      this.setState({processo: response.data});
				this.setState({partes: response.data.partes})
        this.setState({pesquisaProcesso: processo.nrCnj});
        this.setState({selectGrupo: response.data.grupoTrabalho});
        this.setState({exibirComponentesGrupos: 'block'})
        this.setState({bloqueiaGrupo: true});
        this.setState({campoPesquisaProcesso: 'none'});
        this.setState({processoPesquisadoVisivel: 'block'});
        if(response.data.nrCnj != '' && response.data.nrCnj != null) {
          var cnjMascarado = response.data.nrCnj.substring(0, 7);
              cnjMascarado = cnjMascarado + "-" + response.data.nrCnj.substring(7, 9);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(9, 13);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(13, 14);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(14, 16);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(16, 20);
          this.setState({processoPesquisado: cnjMascarado});
        } else {
          this.setState({processoPesquisado: response.data.nrProcesso});
        }
        //this.setState({sizePesquisa: 'col-sm-12'});
        this.setState({escondeBotalExcluirPesquisa: {
          display: 'block'
        }});
        this.consultarSubGrupos();
        this.listarResponsaveisAtivos();
        this.listarInteressadosAtivos();
        this.fecharModalAtividade('displayProcesso');
      }).catch(error => {
        this.setState(error.response.data);
        //this.setState({openSpinner: false});
        this.setState({classeDiv: 'hide'});
        this.setState({separador: 'none'});
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      //this.setState({openSpinner: false});
      this.setState({classeDiv: 'hide'});
      this.setState({separador: 'none'});
  }

  excluirPesquisaProcesso = () => {
    this.setState({processo: null});
		this.setState({partes: []});
    this.setState({pesquisaProcesso: ''});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({processoPesquisado: ''});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({escondeBotalExcluirPesquisa: {
      display: 'none'
    }});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({bloqueiaGrupo: false});
    this.setState({selectGrupo: null});
    this.setState({subGrupos: null});
    this.setState({selectSubGrupo: null});
    this.setState({interessado: null});
    this.setState({responsavel: null});
    this.setState({responsaveis: []});
  }

  excluirPesquisaPessoa = () => {
    this.setState({pessoa: null});
    this.setState({pessoaPesquisada: ''});
    this.setState({pessoaPesquisa: ''});
    this.setState({campoPesquisaPessoa: 'block'});
    this.setState({processoPesquisado: ''});
    this.setState({pessoaPesquisadoVisivel: 'none'});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      if(this.state.tituloAtividade == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    } else {
      if(this.state.titulo == '') {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    if(this.state.pessoaPesquisa != '' && this.state.pessoa == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Atenção! você informou algum valor no campo destinado a pessoa e não o pesquisou. Pressionee enter sobre o nome para realizar a pesquisa e selecionar a pessoa', life: 9000});
      return false;
    }

    if(this.state.pesquisaProcesso != '' && this.state.processo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Atenção! você informou algum valor no campo destinado a processo e não o pesquisou. Pressionee enter sobre o campo de processo para realizar a pesquisa e selecionar o procsso', life: 9000});
      return false;
    }

    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    //Responsaveis
    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    //Interessados
    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    } else {
      interessados = null;
    }

    var titulo = '';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    var processo = null;
    if(this.state.processo != null) {
      processo = {
        codigo: this.state.processo.codigo
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';

    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    const cadastroAtividade = {
      atividade: {
        titulo: titulo,
        processo: processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        //configuracaoTarefa: this.state.configuracaoTarefa,
        status: {
          codigo: 1
        }, // Ativo
        importante: importante,
        urgente: urgente,
        privado: privado,
        pessoa: this.state.pessoa,
        tituloAtividade: this.state.tituloAtividade,
        lancamentoFinanceiro: null
      },
      responsaveis: this.state.responsavel,
      interessados: this.state.interessado,
      arquivos: this.formData,
      recorrencia: recorrencia,
      responsaveisSubTarefas: null,
      interessadosSubTarefas: null,
      empresaId: usuarioLogado.empresa.codigo
    }
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    this.setState({desabilitaBotao: true});
    await this.atividadeService.cadastrarAtividade(cadastroAtividade).
      then(response => {
        this.cadastrarExecucaoCheckList(response.data);
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
        this.setState({classeDiv: 'hide'});
        this.setState({separador: 'none'});
        this.refreshPage();
        this.fecharModalAtividade('displayAtividade');
    }).catch(error => {
      this.setState({classeDiv: 'hide'});
      this.setState({separador: 'none'});
      this.setState({desabilitaBotao: false});
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  cadastrarAtividadeComAssociadas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '') {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '') {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    //Responsaveis
    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    //Interessados
    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    } else {
      interessados = null;
    }

    var titulo = '';
    if(usuarioLogado.empresa.codigo == 138) {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }
    const cadastroAtividade = {
      atividade: {
        titulo: titulo,
        processo: this.state.processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        configuracaoTarefa: this.state.configuracaoTarefa,
        status: {
          codigo: 1
        } // Ativo
      },
      responsaveis: this.state.responsavel,
      interessados: this.state.interessado,
      responsaveisSubTarefas: this.state.responsavelSubTarefa,
      interessadosSubtarefas: this.state.interessadoSubTarefa
    }
    this.setState({openSpinner: true});
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    this.setState({desabilitaBotao: true});
    await this.atividadeService.cadastrarAtividade(cadastroAtividade).
      then(response => {
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
    }).catch(error => {
      //this.fecharModalCadastro('wait')
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({desabilitaBotao: false});
    this.setState({classeDiv: 'hide'});
    this.setState({separador: 'none'});
    this.setState({openSpinner: false});
    this.refreshPage();
  }

  limparCamposAtividade = () => {
    this.setState({processo: null});
    this.setState({titulo: ''});
    this.setState({hora: ''});
    this.setState({descricao: ''});
    this.setState({dtLimite: ''});
    this.setState({hora: ''});
    this.setState({dtFatal: ''});
    this.setState({tipo: ''});
    this.setState({status: ''});
    this.setState({responsavel: null});
    this.setState({interessado: null});
    this.setState({responsaveis: []});
    this.setState({selectGrupo: null});
    this.setState({selectSubGrupo: null});
  }

  refreshPage = () => {
    window.location.reload();
  }

  //Tudo referente a upload de arquivos

  //Upload de Documentos
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    await this.arquivoAtividadeService.incluirArquivoTemp(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-images" className="p-button-rounded p-button-text"
                      tooltip="Consultar Arquivo"
                      tooltipOptions={{position: 'top'}}
                      onClick={() => this.exibirArquivo(rowData)}
                      style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.download(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoAtividadeService.downloadTemp(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  async consultarArquivoDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  async consultarArquivo(arquivo){
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivo = () => {
    this.arquivoAtividadeService.excluirArquivoTemp(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  excluirArquivos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        console.log('Arquivos excluídos com sucesso');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/> 
            &nbsp;
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.adicionarDescricao}/> 
        </div>
    );
  }

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricaoTemp({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosTemp();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  notificacoesQuantidade = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.centralService.totalNotificacoesPorUsuario(usuarioLogado.codigo)
      .then(response => {
         this.setState({quantidadeNotificacoes: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Central de Notificacoes', detail:`${this.state.detail}`, life: 4000});
      })
   }

   pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
   }

   quantidadePush = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const dataAtual = new Date();
    var dataCarregamento = dataAtual;
    var month = this.pad2(dataCarregamento.getMonth()+1);//months (0-11)
    var day = this.pad2(dataCarregamento.getDate());//day (1-31)
    var year= dataCarregamento.getFullYear();
    dataCarregamento =  year+"-"+month+"-"+day;

    this.pushService.quantidadePush(usuarioLogado.empresa.codigo, dataCarregamento)
      .then(response => {
        this.setState({quantidadePush: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Push do dia', detail:`${this.state.detail}`, life: 4000});
      })
   }

   consultarPublicacoes = async () => {
      const usuarioLogado = this.context.usuarioAutenticado;
      await this.publicacoesService.consultarPublicacoesPordataAtual(usuarioLogado.empresa.codigo)
        .then(response => {
          this.setState({quantidadePublicacoes: response.data.length});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Publicações do dia', detail:`${this.state.detail}`, life: 4000});
        })
   }

   componentDidMount() {
    this.notificacoesQuantidade();
    this.quantidadePush();
    this.consultarPublicacoes();
    this.verificarUsuarioTriagem();
  }

  verificarUsuarioTriagem = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if (!usuarioLogado || !usuarioLogado.empresa) {
      return;
    }
    await this.parametrosPublicacoesService.consultar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarioTriagem: response.data != null && response.data.usuarioTriagem === usuarioLogado.codigo});
      }).catch(() => {
        this.setState({usuarioTriagem: false});
      })
  }

  home = () => {
    this.props.history.push('/home');
  }

  onGrauChange(e) {
    let selectedGrau = [...this.state.grau];

    if (e.checked)
      selectedGrau.push(e.value);
    else
      selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

    this.setState({ grau: selectedGrau });
  }

  onChangeCheckList(e) {
    if(e.value != null) {
      this.itens = [];
      this.setState({tituloAtividade: e.value});
      this.consultarCheckList(e.value.codigo);
    } else {
      this.setState({tituloAtividade: null});
      this.itens = [];
    }
  }

  consultarCheckList = async (atividade) => {
    this.setState({openSpinner: true});
    await this.checkListAtividadeService.listar(atividade)
      .then(response => {
        this.setState({checkList: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Checklista de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      let item = null;
      for(let i = 0; i < this.state.checkList.length; i++) {
        item = {
          label: this.state.checkList[i].tarefa
        }
        this.itens.push(item);
      }
      this.setState({openSpinner: false});
  }

  cadastrarExecucaoCheckList = async (atividade) => {
    const execucao = {
      atividade: atividade,
      checkList: this.state.checkList
    };

    await this.execucaoCheckListService.cadastrar(execucao)
      .then(response => {
        console.log('Dados de checklist cadastrado com sucesso');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Checklista de Tarefas - EXecução', detail:`${this.state.detail}`, life: 4000});
      })
  }

  novoTituloAtividade = async () => {
    this.setState({novoTitulo: ''});
    this.setState({pontuacao: ''});
    this.setState({openSpinner: true});
    this.setState({openSpinner: false});
    this.abrirModal('modalNovoTitulo');
  }

  cadastrarNovoTitulo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.novoTitulo == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'Informe o título da atividade', life: 5000});
      return;
    }

    if(this.state.pontuacao == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'Informe a pontuação do título', life: 5000});
      return;
    }

    const titulo = {
      titulo: this.state.novoTitulo,
      pontos: this.state.pontuacao,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    await this.tituloAtividadeService.cadastrar(titulo)
      .then(response => {
        this.listarTitulos();
        this.fecharModal('modalNovoTitulo');
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Novo títilo cadatrado com sucesso!', life: 5000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${error}`, life: 5000});
      })
  }

  novoGrupoTrabalho = () => {
    this.setState({novoGrupo: ''});
    this.setState({novaDescricaoGrupo: ''});
    this.abrirModal('modalNovoGrupo');
  }

  cadastrarGrupoTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.novoGrupo == '') {
      this.toast.show({severity:'error', summary: 'Grupos de Trabalho', detail:'Informe o nome do Grupo de Trabalho', life: 5000});
      return;
    }

    const grupo = {
      nome: this.state.novoGrupo,
      descrica: this.state.novaDescricaoGrupo,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    await this.grupoTrabalhoService.cadastrarGrupo(grupo)
      .then(response => {
        //Atualiza os Grupos
        this.consultarGruposTrabalho();
        this.toast.show({severity:'error', summary: 'Grupos de Trabalho', detail:'Grupo de Trabalho cadastrado com sucesso', life: 5000});
        this.fecharModal('modalNovoGrupo');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Grupos de Trabalho', detail:`${error}`, life: 5000});
      })
  }

  async exibirArquivo(arquivo){
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.arquivoAtividadeService.exibirArquivoTemp(arquivo.arquivo,usuarioLogado.codigo)
      .then(response => {
        const url = URL.createObjectURL(response.data); // Cria uma URL local para o arquivo
        this.setState({fileData: url});
        this.setState({fileName: arquivo.arquivo});
        this.abrirModal('modalExibirArquivo');
      }).catch(error => {
        this.setState({openSpinner: false});
        console.log("Erro ao buscar o arquivo", error);
      });
      this.setState({openSpinner: false});
  }  

  render() {
   const { upLoadFiles } = this.state;
   const modoFoco = this.props.modoFoco || false;
   const usuarioLogado = this.context.usuarioAutenticado;
   const usuarioNome = usuarioLogado.nome;
   const usuarioPerfil = usuarioLogado.perfil.codigo;
   var gerencia = 'none';
   var financeiro= 'none';
   var administracao = 'none';
   var relatorio = 'none';
   var tituloPredefinidoSim = 'none';
   var tituloNaoPredefinido = 'block';
   var criaTitulo = 'none';
   var criaGrupo = 'none';

   if(usuarioLogado.empresa.tituloPredefinido == 'S') {
    tituloPredefinidoSim = 'block';
    tituloNaoPredefinido = 'none';
   } else {
    tituloPredefinidoSim = 'none';
    tituloNaoPredefinido = 'block';
   }

   if(usuarioPerfil == 1) {
     gerencia = 'hide';
     administracao = 'hide';
     relatorio = 'hide';
   }

   if(usuarioPerfil == 1 || usuarioPerfil == 9) {
    financeiro = 'hide'
   }

   if(usuarioPerfil == 1 || usuarioPerfil == 2) {
      criaTitulo = 'block';
   }

   if(usuarioPerfil == 1 || usuarioPerfil == 2) {
      criaGrupo = 'block';
   }

   const notif = this.state.quantidadeNotificacoes == 0 ? 0 : this.state.quantidadeNotificacoes;
   const push = this.state.quantidadePush == 0 ? 0 : this.state.quantidadePush;
   const publicacoes = this.state.quantidadePublicacoes == 0 ? 0 : this.state.quantidadePublicacoes;
   const notficacoesTotal = (notif+push+publicacoes);


   addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Claro'
    });

  locale('es');

    return (
      <div className={`hold-transition dark-mode${modoFoco ? '' : ' sidebar-mini layout-fixed layout-navbar-fixed layout-footer-fixed'}`}>
        <Toast ref={(el) => this.toast = el} />
        {!modoFoco && (
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
            </li>
          </ul>

					<RodizioAtividadeComponent
							visible={this.state.modalRodizio}
							onHide={this.fecharRodizio}
							executarNovaAtividade={this.state.modalRodizio}
					/>

          <ul className="navbar-nav ml-auto bodyBar2">
            <li className="nav-item">
              <a className="nav-link" data-widget="navbar-search" href="#" role="button">
                <i className="fas fa-search"></i>
              </a>
              <div className="navbar-search-block">
                <form className="form-inline">
                  <div className="input-group input-group-sm">
                    <input className="form-control form-control-navbar" 
                           type="input" 
                           placeholder="Pesquise processos por pasta, partes ou numeração" 
                           aria-label="Search"
                           value={this.state.consultaProcessoTopo}
                           onKeyPress={event => event.key === 'Enter' && this.consultarProcessoTopo()}
                           onChange={e => this.setState({consultaProcessoTopo: e.target.value})}/>
                    <div className="input-group-append">
                      <button className="btn btn-navbar" type="submit">
                        <i className="fas fa-search"></i>
                      </button>
                      <button className="btn btn-navbar" type="button" data-widget="navbar-search">
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </li>

            <li className="nav-item">
              <a href="#/pessoas" className="nav-link cursor" title="Pessoas">
                <i className="fa fa-users"></i>
              </a>
            </li>

            <li className="nav-item">
              <a href="#/cadastrarProcesso" className="nav-link cursor" title="Novo Processo">
                <i className="fa fa-balance-scale"></i>
              </a>
            </li>
            

						<li className="nav-item dropdown">
							<a className="nav-link" data-toggle="dropdown" href="#">
                <i className="fa fas fa-tasks"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span className="dropdown-item dropdown-header">Opções</span>
                <div className="dropdown-divider"></div>
                <a style={{cursor: 'pointer'}} onClick={() => this.abrirModalAtividade('displayAtividade')} 
									 className="dropdown-item">
                  <i class="fas fa-user"></i>&nbsp;&nbsp;Atividade Individual
                </a>
                <div className="dropdown-divider"></div>
                <a style={{cursor: 'pointer'}} onClick={this.abrirRodizio} className="dropdown-item">
                  <i class="fas fa-users"></i>&nbsp;&nbsp;Rodízio
                </a>
              </div>
            </li>


            <li className="nav-item">
              <a href="#/agenda" className="nav-link cursor" title="Agenda">
                <i className="fa fa-calendar-alt"></i>
              </a>
            </li>

            <Dialog
                  visible={this.state.wait}>
              <div>
                <h2>Aguarde...</h2>
              </div>
            </Dialog>
            {/**Informação de usuário */}
            <Dialog header="Usuários da Tarefa"
                    style={{ width: '30vw' }} 
                    visible={this.state.modalInformacaoUsuario} 
                    footer={this.renderFooterInformacaoUsuario('modalInformacaoUsuario')} 
                    onHide={() => this.fecharModalAtividade('modalInformacaoUsuario')}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                  <DataTable value={this.state.usuariosTarefas} emptyMessage="Nenum usuário para esta tarefa">
                    <Column field="usuario.nome" header="Usuário"></Column>
                  </DataTable>
                  </div>
                </div>
              </div>   
            </Dialog>
            <AtividadeInclusaoModal
              key={this.state.displayAtividade ? 'atividade-open' : 'atividade-closed'}
              visible={this.state.displayAtividade}
              dtLimiteInicial={null}
              onHide={() => this.setState({ displayAtividade: false })}
              onCadastrado={this.refreshPage}
            />

            
            <li className="nav-item dropdown bodyBar2">
              <a className="nav-link" data-toggle="dropdown" href="#">
                <i className="far fa-bell"></i>
                  {Number(notficacoesTotal) > 0 && (
                    <span className="badge badge-danger navbar-badge">{notficacoesTotal}</span>
                  )}
              </a>
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span className="dropdown-item dropdown-header">
                  {Number(notficacoesTotal) > 0 ? `${notficacoesTotal} Notificações` : 'Notificações'}
                </span>
                <div className="dropdown-divider"></div>
                <a href="#/centralNotificacoes" className="dropdown-item">
                  <i className="fas fa-envelope mr-2"></i> {Number(notif) > 0 ? `${notif} Central` : 'Central'}
                </a>
                <div className="dropdown-divider"></div>
                <a href="#/push" className="dropdown-item">
                  <i className="fas fa-users mr-2"></i> {Number(push) > 0 ? `${push} Push` : 'Push'}
                </a>
                <div className="dropdown-divider"></div>
                <a href="#/publicacoes" className="dropdown-item">
                  <i className="pi pi-book mr-2"></i> {Number(publicacoes) > 0 ? `${publicacoes} Publicações` : 'Publicações'}
                </a>
                <div className="dropdown-divider"></div>
                <div className="dropdown-divider"></div>
              </div>
            </li>
           <li className="nav-item dropdown">
              <a className="nav-link" data-toggle="dropdown" href="#">
                <div className="info">
                  <a href="#" className="d-block">{usuarioNome}</a>
                </div>
              </a>

              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span className="dropdown-item dropdown-header">Administrador</span>
                <div className="dropdown-divider"></div>
                <a href="#" className="dropdown-item">
                  <i className="fas fa-users-cog mr-2"></i>Configurações
                </a>
                <div className="dropdown-divider"></div>
                <a href="#/alterarSenha" className="dropdown-item">
                  <i className="fas fa-key mr-2"></i> Alterar Senha
                </a>
                <a href="#/login" onClick={this.sairSistema} className="dropdown-item">
                <i className="fas fa-sign-out-alt mr-2"></i> Sair
                </a>
              </div>
            </li>
          </ul>
        </nav>
        )}

        {!modoFoco && (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
          <a onClick={this.home} style={{cursor: 'pointer', marginTop: '4px'}} className="brand-link">
            <img src={Logo} alt="iLaw Gestão" className="brand-image img-circle elevation-3"/>
            <span className="brand-text font-weight-light">iLaw Gestão</span>
          </a>
          <div className="sidebar bodyBar">
            <nav>
              <br></br>
              <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li className="nav-item" style={{display: 'hide'}}>
                  <a href="#" className="nav-link" style={{display: `${gerencia}`}}>
                    <i className="nav-icon fas fa-tachometer-alt"></i>
                    <p>
                      Gerencial
                      <i className="right fas fa-angle-left"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/painelProcesso" className="nav-link">
                        <i className="pi pi-table nav-icon"></i>
                        <p>Processos</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/graficosAtividades" className="nav-link">
                        <i className="pi pi-sitemap nav-icon"></i>
                        <p>Atividades</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/painelPessoas" className="nav-link">
                        <i className="pi pi-user nav-icon"></i>
                        <p>Pessoas</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fa fa-solid fa-network-wired"></i>
                    <p>
                      Atividades
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/home" className="nav-link">
                        <i className="fas fa-chalkboard-teacher nav-icon"></i>
                        <p>Meu Painel</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/agenda" className="nav-link">
                        <i className="fas fa-search-plus nav-icon"></i>
                        <p>Agenda</p>
                      </a>
                    </li>
                    {this.state.usuarioTriagem && (
                    <li className="nav-item">
                      <a href="#/prazosSemResponsavel" className="nav-link">
                        <i className="fas fa-user-clock nav-icon"></i>
                        <p>Prazos sem Responsável</p>
                      </a>
                    </li>
                    )}
                  </ul>
                </li>          
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fas fa-balance-scale"></i>
                    <p>
                      Processos
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/cadastrarProcesso" className="nav-link">
                        <i className="fas fa-plus-circle nav-icon"></i>
                        <p>Incluir Processo</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/processos" onClick={this.limparConsultaProcesso} className="nav-link">
                        <i className="fas fa-search-plus nav-icon"></i>
                        <p>Pesquisa</p>
                      </a>
                    </li>
                    <li className="nav-item" style={{display: `${gerencia}`}}>
                      <a href="/#processosExcluidos" className="nav-link">
                        <i className="pi pi-times-circle nav-icon"></i>
                        <p>Processos Excluídos</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fas fa-user-tie"></i>
                    <p>
                      Pessoas
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/cadastrarPessoa" className="nav-link">
                        <i className="fas fa-plus-circle nav-icon"></i>
                        <p>Cadastrar</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/pessoas" onClick={this.limparConsultarPessoas} className="nav-link">
                        <i className="fas fa-search-plus nav-icon"></i>
                        <p>Pesquisar</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#/publicacoes" className="nav-link">
                    <i className="nav-icon fa fa-file-import"></i>
                    <p>
                      Publicações
                    </p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link" style={{display: `${financeiro}`}}>
                  <i className="fas fa-hand-holding-usd nav-icon"></i>
                    <p>
                       Financeiros
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/painelFinanceiro" className="nav-link">
                        <i className="fas fa-chart-bar nav-icon"></i>
                        <p>Painel</p>
                      </a>
                    </li>
                  </ul>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/tiposDespesasReceitas" className="nav-link">
                        <i className="fa fas fa-shapes nav-icon"></i>
                        <p>Tipos Despesas Receitas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/relatoriosFinanceiro" className="nav-link">
                        <i className="fas fa-file-contract nav-icon"></i>
                        <p>Relatórios</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/contasFinanceiras" className="nav-link">
                        <i className="fa fa-money-check-alt nav-icon"></i>
                        <p>Contas Financeiras</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#/home" className="nav-link">
                    <i className="nav-icon fas fa-archway"></i>
                    <p>
                      Central de Documentos
                    </p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#/relatoriosFinanceiro" className="nav-link">
                    <i className="nav-icon fas fa-file-export"></i>
                    <p>
                      Relatórios
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/relatorioProcessos" className="nav-link">
                        <i className="fas fa-file-contract nav-icon"></i>
                        <p>Processos</p>
                      </a>
                    </li>
                  </ul>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/relatorioAtividades" className="nav-link">
                        <i className="fas fa-file-contract nav-icon"></i>
                        <p>Atividades</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link" style={{display: `${gerencia}`}}>
                    <i className="nav-icon fas fa-cogs"></i>
                    <p>
                      Administração
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/usuarios" className="nav-link">
                        <i className="fas fa-users nav-icon"></i>
                        <p>Usuários</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/grupoTrabalho" className="nav-link">
                        <i className="fas fa-boxes nav-icon"></i>
                        <p>Grupos de Trabalho</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/gruposPessoas" className="nav-link">
                        <i className="fas fa-people-carry nav-icon"></i>
                        <p>Grupos de Pessoas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/pedidos" className="nav-link">
                        <i className="pi pi-dollar nav-icon"></i>
                        <p>Tipos de Pedidos</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tipoAndamentoProcessual" className="nav-link">
                        <i className="pi pi-list nav-icon"></i>
                        <p>Andamentos Processuais</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposPagamentos" className="nav-link">
                        <i className="fas fa-cash-register nav-icon"></i>
                        <p>Tipos de Pagamentos</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposCustas" className="nav-link">
                        <i className="fas fa-dollar-sign nav-icon"></i>
                        <p>Tipos de Custas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/statusProcessual" className="nav-link">
                        <i className="fas fa-stream nav-icon"></i>
                        <p>Status Processual</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/objetosAcao" className="nav-link">
                        <i className="far fa-object-ungroup nav-icon"></i>
                        <p>Objetos de Ação</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/areaAtuacao" className="nav-link">
                        <i className="pi pi-book nav-icon"></i>
                        <p>Áreas de Atuação</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposDecisao" className="nav-link">
                        <i className="fab fa-codepen nav-icon"></i>
                        <p>Tipos de Decisão</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tipoAcao" className="nav-link">
                        <i className="pi pi-share-alt nav-icon"></i>
                        <p>Tipos de Ação</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/motivoResultado" className="nav-link">
                        <i className="pi pi-wallet nav-icon"></i>
                        <p>Motivos de Resultado</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/ritos" className="nav-link">
                        <i className="pi pi-check-square nav-icon"></i>
                        <p>Ritos de Processo</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposGarantias" className="nav-link">
                        <i className="fas fa-university nav-icon"></i>
                        <p>Tipos de Garantias de Processo</p>
                      </a>
                    </li>
										<li className="nav-item">
                      <a href="#/gruposAtividades" className="nav-link">
                        <i class="fa fa-object-ungroup nav-icon"></i>
                        <p>Grupos de Atividade</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/titulosAtividades" className="nav-link">
                        <i className="pi pi-tablet nav-icon"></i>
                        <p>Títulos de Atividades</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/statusAtividades" className="nav-link">
                        <i className="pi pi-tablet nav-icon"></i>
                        <p>Status das Atividades</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/parametrosPublicacoes" className="nav-link">
                        <i className="fa fa-file-import nav-icon"></i>
                        <p>Parâmetros de Publicações</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposBeneficio" className="nav-link">
                        <i className="pi pi-tablet nav-icon"></i>
                        <p>Tipos de Benefício - (Previdenciário)</p>
                      </a>
                    </li>
                  </ul>
                </li>    
              </ul>
            </nav>
          </div>
        </aside>
        )}
      </div>
    )
  }
}

Navbar.contextType = AuthContext;

export default withRouter(Navbar)
